import { cn } from '@/utils/utils';
import { ButtonHTMLAttributes, ReactNode } from 'react';

import './style.scss';
import classNames from 'classnames';

interface AnimateButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string,
    parentClassName?: string,
    textClassName?: string,
    contentComp?: string | ReactNode,
    children?: ReactNode,
    outline?: boolean,
    disabled?: boolean,
    side?: 'left' | 'right',
    iconArrowClassName?: string
}

export default function AnimateButton({ onClick, className, parentClassName, contentComp, outline, disabled, textClassName, type = 'button', side = 'right', iconArrowClassName, ...props }: AnimateButtonProps) {
    return (
        <div className={cn(
            'rect-button',
            side === 'left' && 'rect-button-left',
            outline && 'cs-outline',
            disabled && 'cs-disabled',
            parentClassName
        )}
        >
            <button
                className={cn('w-full h-full', disabled ? 'cursor-default' : 'cursor-pointer', className)}
                onClick={onClick}
                disabled={disabled}
                type={type}
                {...props}
            >
                {contentComp && (
                    <span className={cn('text-fs-mid16', side === 'right' ? 'right-side' : 'left-side', textClassName)}>
                        {contentComp}
                        <svg className={classNames(
                            side === 'right' ? 'icon-right' : 'icon-left',
                            iconArrowClassName
                        )}
                        >
                            <use href='#btn-arrow'></use>
                        </svg>
                    </span>
                )}
            </button>
        </div>
    );
}
